function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import classnames from "classnames";
import { MD, XS } from "constants/sizes";
import { StyledSlidingCardComponent } from "./sliding-card-component.scss";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
const CARD_DEFAULT_PROPS = {
    width: "100%",
    height: "100%",
    titleSize: XS,
    textSize: MD
};
const SlidingCardComponent = ({ card, disableCardsHoverStyle, fullParagraphAdvancedConfig, backgroundHoverColor, borderOpacity, borderColor, cardColor, padding, sideBySideImage, reverseImageAndText, imageOnTop })=>{
    const [isHovered, setIsHovered] = useState(false);
    const backLayer = card === null || card === void 0 ? void 0 : card.backLayer;
    const cardBackgroundColor = useMemo(()=>isHovered && backgroundHoverColor ? backgroundHoverColor : cardColor, [
        isHovered,
        backgroundHoverColor,
        cardColor
    ]);
    const isBackLayerEnabled = Boolean(backLayer === null || backLayer === void 0 ? void 0 : backLayer.enable);
    const onCardHover = ()=>{
        setIsHovered((isHover)=>!isHover);
    };
    return /*#__PURE__*/ _jsxs(StyledSlidingCardComponent, {
        reverseImageAndText: reverseImageAndText,
        padding: padding,
        className: classnames("sliding-card-component", {
            "side-by-side-image": sideBySideImage
        }),
        isFlipped: isBackLayerEnabled && isHovered,
        onMouseEnter: onCardHover,
        onMouseLeave: onCardHover,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classnames("card", "card-front-layer"),
                children: /*#__PURE__*/ _jsx(GridParagraphWithImage, _object_spread(_object_spread_props(_object_spread({}, card), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, card.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardBackgroundColor,
                    padding: padding,
                    imageOnTop: imageOnTop
                }), CARD_DEFAULT_PROPS))
            }),
            isBackLayerEnabled && /*#__PURE__*/ _jsx("div", {
                className: classnames("card", "card-back-layer"),
                children: /*#__PURE__*/ _jsx(GridParagraphWithImage, _object_spread(_object_spread_props(_object_spread({}, backLayer), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, backLayer.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardColor,
                    padding: padding,
                    imageOnTop: imageOnTop
                }), CARD_DEFAULT_PROPS))
            })
        ]
    });
};
export default SlidingCardComponent;
